import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Podcast from "./pages/Podcast";
import EpisodeDetail from "./pages/EpisodeDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Shop from "./pages/Shop";
import WorkWithUs from "./pages/WorkWithUs";
import Community from "./pages/Community";
import Speaking from "./pages/Speaking";
import Assessments from "./pages/Assessments";
import Resources from "./pages/Resources";
import Guests from "./pages/Guests";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation(); // read hash from here (reactive), not window.location.hash
  // Process the OAuth return FIRST, before any protected-route redirect runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/podcast" element={<Podcast />} />
      <Route path="/podcast/:id" element={<EpisodeDetail />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/work-with-us" element={<WorkWithUs />} />
      <Route path="/community" element={<Community />} />
      <Route path="/speaking" element={<Speaking />} />
      <Route path="/assessments" element={<Assessments />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/guests" element={<Guests />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-cream">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <AppRouter />
          </main>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
